import { updateSchemaWithDefaults } from '@/catalog-apps/components/AppPage2/Filter/useGetPageFilters'
import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilterPopover } from '@/components/ui/TileFilterPopover'
import { useCallback, useState } from 'react'
import { FormValues, JsonFormSchemaV2 } from '../../FormComponent/types'
import { Filters } from '../shared-types'
import { TileFilterContent } from './TileFilterContent'

interface TileFilterProps {
  schema?: Filters
  className?: string
  resetDefaults?: FormValues
  isSubmitting?: boolean
  /** Set false when rendered inside a portalled sheet so the filter popover can scroll. */
  portalPopover?: boolean
}

// Type guard to check if schema is JsonFormSchemaV2
function isJsonFormSchemaV2(schema: Filters | undefined): schema is JsonFormSchemaV2 {
  return (
    schema != null &&
    typeof schema === 'object' &&
    'type' in schema &&
    schema.type === 'object' &&
    'properties' in schema &&
    Array.isArray(schema.properties)
  )
}

export function TileFilter({
  schema,
  className,
  resetDefaults,
  isSubmitting,
  portalPopover = true,
}: TileFilterProps) {
  const [open, setOpen] = useState(false)
  const { filterChangeHandler, tileFilterSelections } = useTileFilters()
  const submitHandler = useCallback(
    (data: FormValues) => {
      filterChangeHandler(data)
      setOpen(false)
    },
    [filterChangeHandler]
  )
  if (!isJsonFormSchemaV2(schema)) return null
  return (
    <TileFilterPopover open={open} onOpenChange={setOpen} portal={portalPopover}>
      <TileFilterContent
        schema={updateSchemaWithDefaults(schema, tileFilterSelections)}
        submitHandler={submitHandler}
        resetDefaults={resetDefaults}
        isSubmitting={isSubmitting}
        className={className}
      />
    </TileFilterPopover>
  )
}
